<template>
    <div class="confirm-summary clearfix">
        <div class="image">
            <img src="../../assets/images/IMG_1219.jpg" alt="Top Destinations">
        </div>
        <div class="heading">
            <div class="raty-wrapper sp-2 mb-5">
                <div class="star-rating-12px" data-rating-score="4"></div>
            </div>
            <h4>Vola Room</h4>
            <p>Lleida, España - <a target="_blank" rel="noopener noreferrer"
                                   href="https://www.google.es/maps/place/VOLA/@41.6052836,0.6098992,17z/data=!3m1!4b1!4m5!3m4!1s0x12a6e01275f493b3:0x98a69b6f97d357c5!8m2!3d41.6052836!4d0.6120879"
                                   class="font13 anchor" data-toggle="tab">
                <font-awesome-icon icon="map-marker-alt"/>
                Ver en mapa</a></p>
        </div>
        <div class="content">
            <div class="confirm-date">
                <div class="icon">
                    <font-awesome-icon icon="calendar"/>
                </div>
                <div class="content">
                    <ul>
                        <li><span class="absolute">Check-in: </span>Friday, 14 Jun, 2019 18:00</li>
                        <li><span class="absolute">Check-out: </span>Friday, 14 Jun, 2019 20:00</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "headResume"
    }
</script>

<style scoped>
    .icon {
        background: transparent !important;
    }
</style>